import { XCircleIcon } from '@phosphor-icons/react';
import { EmptyPage } from 'components/EmptyPage/EmptyPage';
import type { FC, ReactElement } from 'react';
import s from './AuthErrorPage.module.scss';

interface AuthErrorPageProps {
  error: string;
  showHeader?: boolean;
  action?: ReactElement;
}

export const AuthErrorPage: FC<AuthErrorPageProps> = ({ error, showHeader = false, action }) => {
  'use memo';

  return (
    <EmptyPage
      showHeader={showHeader}
      size="lg"
      variant="transparent"
      icon={<XCircleIcon weight="bold" className={s.errorIcon} />}
      title="Authentication error"
      subtitle={
        <div className={s.description}>
          <p className={s.error}>{error}</p>
          <p>
            Please contact <a href="mailto:support@ankar.ai">support@ankar.ai</a> if you require assistance
          </p>
        </div>
      }
      action={action}
    />
  );
};
